module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer000"
    }
  }, [_c('p', {
    staticClass: "Other-Books-By-Main-Title"
  }, [_vm._v("Other Books by Amanda Scott")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By-Titles ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_c('b', [_vm._v("Series")])])]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By-Subtitles"
  }, [_vm._v("THE BATH TRILOGY")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("The Bath Quadrille")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("Bath Charade")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("The Bath Eccentric’s Son")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By-Subtitles"
  }, [_vm._v("BORDER NIGHTS")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("Moonlight Raider")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("Devil’s Moon")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By-Subtitles"
  }, [_vm._v("THE BORDER TRILOGY")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("Border Bride")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("Border Fire")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("Border Storm")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By-Subtitles"
  }, [_vm._v("THE BORDER TRILOGY 2")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("Border Wedding")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("Border Lass")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("Border Moonlight")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By-Subtitles"
  }, [_vm._v("THE DANGEROUS SERIES")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("Dangerous Games")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("Dangerous Angels")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("Dangerous Illusions")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("Dangerous Lady")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By-Subtitles"
  }, [_vm._v("THE GALLOWAY TRILOGY")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("Tamed by a Laird")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("Seduced by a Rogue")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("Tempted by a Warrior")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By-Subtitles"
  }, [_vm._v("THE HIGHLAND SERIES")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("Highland Fling")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("Highland Secrets")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("Highland Treasure")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("Highland Spirits")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By-Subtitles"
  }, [_vm._v("THE ISLES/TEMPLARS SERIES")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("Highland Princess")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("Lord of the Isles")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("Prince of Danger")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("Lady’s Choice")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("Knight’s Treasure")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("King of Storms")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By-Subtitles"
  }, [_vm._v("LAIRDS OF THE LOCH")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("The Laird’s Choice")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("The Knight’s Temptress")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("The Warrior’s Bride")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By-Subtitles"
  }, [_vm._v("SCOTTISH KNIGHTS TRILOGY")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("Highland Master")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("Highland Hero")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("Highland Lover")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By-Subtitles"
  }, [_vm._v("THE SECRET CLAN")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("Abducted Heiress")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("Hidden Heiress")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("Highland Bride")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("Reiver’s Bride")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By-Titles"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_c('b', [_vm._v("Novels")])])]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("An Affair of Honor")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("The Battling Bluestocking")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("The Bawdy Bride")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("The Dauntless Miss Wingrave")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("The Fugitive Heiress")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("The Indomitable Miss Hariss")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("The Infamous Rakes")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("The Kidnapped Bride")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("Lady Escapade")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("Lady Hawk’s Folly")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("Lord Abberley’s Nemesis")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("Lord Greyfalcon’s Reward")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("The Madcap Marchioness")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("Mistress of the Hunt")]), _vm._v(" "), _c('p', {
    staticClass: "Other-Books-By"
  }, [_vm._v("The Rose at Twilight")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectStyleOverride-1",
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('p', {
    staticClass: "ORIM-Book-Title",
    attrs: {
      "id": "title"
    }
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("The Reluctant Highlander")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Book-Subtitle"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("A Highland Romance")])]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Author-Name"
  }, [_vm._v("Amanda Scott")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Author-Name"
  }, [_c('img', {
    attrs: {
      "alt": "logo",
      "src": "image/logo2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Dedication _idGenParaOverride-1",
    attrs: {
      "id": "ded"
    }
  }, [_c('em', {
    staticClass: "italic _idGenCharOverride-1"
  }, [_vm._v("To Tom & Kathleen Fashinell,"), _c('br'), _vm._v("two very special friends,"), _c('br'), _vm._v("for always being there, again & again."), _c('br'), _vm._v("Thank You!")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26820204","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Untitled-1.vue
// module id = 66
// module chunks = 0